module.exports = __webpack_public_path__ + "static/media/order_dispatch.852d9af5.svg";